import { render, staticRenderFns } from "./RepairDeviceCard.vue?vue&type=template&id=54fb948a&scoped=true"
import script from "./RepairDeviceCard.vue?vue&type=script&lang=js"
export * from "./RepairDeviceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb948a",
  null
  
)

export default component.exports